export const comdex = {
    chainId: "test-1",
    chainName: "Comdex Test Chain",
    coinDenom: "CMDX",
    coinMinimalDenom: "ucmdx",
    coinDecimals: 6,
    prefix: "comdex",
    rpc: "https://test-rpc.comdex.one",
    rest: "https://test-rest.comdex.one",
    explorer: "https://comets-test.comdex.one",
};